import { action } from 'satcheljs';
import { addCoreDatapointConfig } from 'owa-analytics-actions';
import type { ActionSource } from 'owa-mail-store';
import type FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import { type UTFocusedOtherSelection } from 'owa-unified-telemetry';
import { getMailboxInfo } from 'owa-mail-mailboxinfo';
import getSelectedTableView from 'owa-mail-list-store/lib/utils/getSelectedTableView';

// Select focused view filter
export interface SelectFocusedViewFilterActionMessage {
    focusedViewFilter: FocusedViewFilter;
    actionSource: ActionSource;
}
export const selectFocusedViewFilter: (
    focusedViewFilter: FocusedViewFilter,
    actionSource: ActionSource,
    shouldLog?: boolean
) => SelectFocusedViewFilterActionMessage = action(
    'selectFocusedViewFilter',
    (
        focusedViewFilter: FocusedViewFilter,
        actionSource: ActionSource,
        shouldLog: boolean = true
    ): SelectFocusedViewFilterActionMessage => {
        if (shouldLog && (focusedViewFilter === 0 || focusedViewFilter === 1)) {
            const selectedTableView = getSelectedTableView();
            const mailboxInfo = getMailboxInfo(selectedTableView);

            if (focusedViewFilter === 0) {
                return addCoreDatapointConfig(
                    'TnS_SelectFocusedPivot',
                    mailboxInfo,
                    {
                        customData: [focusedViewFilter, actionSource],
                        unifiedTelemetry: {
                            eventName: 'SwitchFocusedOther',
                            data: {
                                SubAction: 'Focused',
                            },
                        },
                    },
                    {
                        focusedViewFilter,
                        actionSource,
                    }
                );
            } else {
                return addCoreDatapointConfig(
                    'TnS_SelectOtherPivot',
                    mailboxInfo,
                    {
                        customData: [focusedViewFilter, actionSource],
                        unifiedTelemetry: {
                            eventName: 'SwitchFocusedOther',
                            data: {
                                SubAction: 'Other',
                            },
                        },
                    },
                    {
                        focusedViewFilter,
                        actionSource,
                    }
                );
            }
        } else {
            return {
                focusedViewFilter,
                actionSource,
            };
        }
    }
);
